import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';
import { sectionHeading } from '../../styled';

export const JourneyContainerRow = styled(Row)`
  width: 100%;
  background-color: #eaf3ff;
  ${media.mdOnly`
    padding-bottom: ${({ theme }) => theme.x4spacePx}px;
  `};
`;

export const JourneyHeader = styled.div`
  margin: ${({ theme }) => theme.x4spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x7spacePx}px;
  `}
  text-align: center;
  h2 {
    ${sectionHeading}
  }
  p {
    ${({ theme }) => theme.typography.large};
    color: ${({ theme }) => theme.color.spaceGray};
  }
`;

export const Timeline = styled(Row)`
  ${({ theme }) => theme.typography.xLargeStrong};
  color: ${({ theme }) => theme.color.spaceGray};
  position: relative;
  width: 100%;
  height: 100px;
  margin: 0 auto;
  ${media.mdOnly`
    width: 90%;
  `};
  ${media.smDown`
    height: 320px;
    margin: 30px 0px 30px 30px;
    width: 75%;
  `};

  :after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    top: 50%;
    transform: translateY(-50%);
    background: ${({ theme }) => theme.color.brand03};
    ${media.smDown`
      left: 0px;
      top: 145px;
      width: 1px;
      height: 240px;
    `};
  }
`;

export const StyledReactMarkdown = styled('div')`
  p {
    ${({ theme }) => theme.typography.xLargeStrong};
    ${media.smDown`
      padding-left: ${({ theme }) => theme.x4spacePx}px;
      margin-bottom: 0px;
    `};
    ${media.mdOnly`
      ${({ theme }) => theme.typography.baseStrong};
    `};
  }
`;

export const Ellipse = styled.div`
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  width: 9px;
  height: 9px;
  border-radius: 100%;
  background: ${({ theme }) => theme.color.brand03};
  ${media.smDown`
    left: -4px;
    top: 20px;
  `};
`;

export const Date = styled.span`
  ${({ theme }) => theme.typography.large};
  position: absolute;
  top: 65%;
  ${media.smDown`
    padding-left: ${({ theme }) => theme.x4spacePx}px;
    position: static;
  `};
`;
